import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
} from '@mui/material';
import { ResendEmailForm } from '../forms/ResendEmailForm';

export const ForgotPasswordModal = ({
  open,
  onClose,
  forgotPassword,
  isResendingEmail,
}) => {
  const [email, setEmail] = useState('');

  const handleClose = () => {    
      onClose();
      setEmail('');
  };

  const handleSendEmail = async e => {
    e.preventDefault();
    await forgotPassword({ email });
    handleClose();
  };



  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Recupero Password</DialogTitle>
      <DialogContent>
        <p>
          Inserisci il tuo indirizzo email per ricevere le istruzioni per il
          ripristino della password.
        </p>
        <Box mt={2}>
          <ResendEmailForm
            email={email}
            setEmail={setEmail}
            handleSubmit={handleSendEmail}
            isResendingEmail={isResendingEmail}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annulla</Button>
      </DialogActions>
    </Dialog>
  );
};